import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { currencyConversionCalcHighAction, getQuotationDetailAction, setPaymentMethodSelection } from "../../actions/stripe";
import PayoutDetailSkeleton from "./PayoutDetailSkeleton";
import { SUPPORTED_PAYMENT_METHOD } from "../../constants";
import { useNavigate } from "react-router";
import Currency from "../../components/currency";
import PayoutDetailComponent from "./PayoutDetailComponent";
import { sendPublicSupportMessage } from "../../actions/chatv2";

const getEntityId = entity => {
    if (!entity) return "";
    if (typeof entity === "string") return entity;
    return entity?.id || entity?._id || "";
};

export default function PayoutDetail({ onContinue, onBack, planId, isAdvisor, skipFetch = false }) {
    const dispatch = useDispatch();
    const { quotationDetail, quotationDetailLoader } = useSelector(
        state => state.stripe
    );
    const navigate = useNavigate();
    const { paymentMethodSelection } = useSelector((state) => state.stripe);
    const { user } = useSelector((state) => state.user || {});
    const [contactLoader, setContactLoader] = useState(false);

    useEffect(() => {
        if (skipFetch) return;
        dispatch(getQuotationDetailAction(planId));
    }, [dispatch, planId, skipFetch]);

    useEffect(() => {
        let companyId = quotationDetail?.company?._id
        localStorage.setItem("companyId", companyId)
    }, [quotationDetail])


    useEffect(() => {
        dispatch(setPaymentMethodSelection(SUPPORTED_PAYMENT_METHOD.PAY_WITH_CARD));
        calculateCartForceAction();
    }, [quotationDetail, paymentMethodSelection]);

    const calculateCartForceAction = () => {
        const payload = {
            baseReqCurrency: quotationDetail?.currency?.value,
            from: quotationDetail?.currency?.value,
            to: quotationDetail?.currency?.value,
            price: quotationDetail?.price,
            paymentMethodSelection: paymentMethodSelection,
            moduleType: 8,
            quantity: 1,
            isManual: false,
            goldType: null,
        };
        console.log(payload)
        dispatch(currencyConversionCalcHighAction(payload));
    };

    const isAdvisorUser = quotationDetail?.company?.isDefault
    const creatorId = getEntityId(quotationDetail?.createdBy);
    const currentUserId = getEntityId(user);

    const sendMessageToCreator = async () => {
        if (contactLoader) return;

        try {
            setContactLoader(true);
            const planName = quotationDetail?.name || "this plan";
            const participantId = creatorId && creatorId !== currentUserId ? creatorId : "";

            await sendPublicSupportMessage({
                message: `I want to learn more about <b>${planName}</b>`,
                navigate,
                participantId,
            });
        } finally {
            setContactLoader(false);
        }
    };


    return (
        <div className="container p-2">
            {quotationDetailLoader ? (
                <PayoutDetailSkeleton />
            ) : (
                <>
                    <div className="buyProductSectionBgPayout">
                        <div>
                            <PayoutDetailComponent isAdvisor={isAdvisor} step={1} />

                            <p className="amoutLabel">Quoted amount</p>
                            <div className="amoutHolderInput">
                                <p className="amountText">{quotationDetail?.price}</p>
                                <div className="currenctTextHolder">
                                    <img
                                        src={`assets/img/${quotationDetail?.currency?.value}.png`}
                                        alt={quotationDetail?.currency?.value}
                                        style={{ width: 20, height: 20 }}
                                    />
                                    <p className="currenctText"><Currency currency={quotationDetail?.currency?.value || ''} /></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`row mb-4 ${onBack ? "payoutDetailActions" : ""}`}>
                        {onBack && (
                            <div>
                                <button type="button" className="gobackButton w-100" onClick={onBack}>
                                    <p className="m-0">Back</p>
                                </button>
                            </div>
                        )}
                        <div className={onBack ? "" : "col-4"}>
                            <div
                                className="gobackButton"
                                onClick={sendMessageToCreator}
                                style={{ pointerEvents: contactLoader ? "none" : "auto" }}
                            >
                                <p className="m-0">Contact us</p>
                            </div>
                        </div>
                        <div className={onBack ? "payoutDetailPrimaryAction" : "col-8"}>
                            <button
                                style={{ backgroundColor: isAdvisorUser ? "#494DA2" : "#2978B5" }}
                                className="gobackButton continueButton"
                                onClick={onContinue}
                            >
                                <p className="m-0">Proceed to pay</p>
                            </button>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}
